


export const ANCModels = [
  { Modelo: "11", Ver: "1.4.8", description: "Astro Uno       España        AN1 EU0  11", name: "AN1 EU0" },
  { Modelo: "12", Ver: "1.4.8", description: "Astro Uno                     AN1 EU1  12", name: "AN1 EU1" },
  { Modelo: "13", Ver: "0.0.0", description: "Astro Uno                     AN1 ETI  13", name: "AN1 ETI" },
  { Modelo: "14", Ver: "1.4.8", description: "Astro Uno       Rusia         AN1 RUS  14", name: "AN1 RUS" },
  { Modelo: "15", Ver: "0.0.0", description: "Astro Uno                     AN1 AOM  15", name: "AN1 AOM" },
  { Modelo: "16", Ver: "0.0.0", description: "Astro Uno       Israel        AN1 ISR  16", name: "AN1 ISR" },
  { Modelo: "17", Ver: "0.0.0", description: "Astro Uno                     AN1 OCE  17", name: "AN1 OCE" },
  { Modelo: "18", Ver: "0.0.0", description: "Astro Uno                     AN1 LAT  18", name: "AN1 LAT" },
  { Modelo: "19", Ver: "1.4.8", description: "Astro Uno                     AN1 EU2  19", name: "AN1 EU2" },
  { Modelo: "1A", Ver: "0.0.0", description: "Astro Uno       Suiza         AN1 SUE  1A", name: "AN1 SUE" },
  { Modelo: "1B", Ver: "1.4.8", description: "Astro Uno                     AN1 LAT2 1B", name: "AN1 LAT2" },
  { Modelo: "1C", Ver: "1.4.8", description: "Astro Uno       Italia        AN1 EU3  1C", name: "AN1 EU3" },
  { Modelo: "1E", Ver: "0.0.0", description: "Astro Uno       EUE este      AN1 EUE  1E", name: "AN1 EUE" },

  { Modelo: "51", Ver: "1.4.8", description: "Astro Nova City España        ANC EU0  51", name: "ANC EU0" },
  { Modelo: "52", Ver: "1.4.8", description: "Astro Nova City No/Su/Is      ANC EU1  52", name: "ANC EU1" },
  { Modelo: "53", Ver: "0.0.0", description: "Astro Nova City               ANC ETI  53", name: "ANC ETI" },
  { Modelo: "54", Ver: "1.4.8", description: "Astro Nova City Rusia         ANC RUS  54", name: "ANC RUS" },
  { Modelo: "55", Ver: "0.0.0", description: "Astro Nova City Afri/Asia     ANC AOM  55", name: "ANC AOM" },
  { Modelo: "56", Ver: "0.0.0", description: "Astro Nova City Israel        ANC ISR  56", name: "ANC ISR" },
  { Modelo: "57", Ver: "0.0.0", description: "Astro Nova City Paci/Amer     ANC OCE  57", name: "ANC OCE" },
  { Modelo: "58", Ver: "0.0.0", description: "Astro Nova City               ANC LAT  58", name: "ANC LAT" },
  { Modelo: "59", Ver: "1.4.8", description: "Astro Nova City Dinamarca     ANC EU2  59", name: "ANC EU2" },
  { Modelo: "5A", Ver: "1.4.8", description: "Astro Nova City Suiza         ANC SUE  5A", name: "ANC SUE" },
  { Modelo: "5B", Ver: "1.4.9", description: "Astro Nova City Sudamerica    ANC LAT2 5B", name: "ANC LAT2" },
  { Modelo: "5C", Ver: "1.4.8", description: "Astro Nova City Ita/Port      ANC EU3  5C", name: "ANC EU3" },
  { Modelo: "5E", Ver: "0.0.0", description: "Astro Nova City EUE este      ANC EUE  5E", name: "ANC EUE" },

  { Modelo: "91", Ver: "1.4.7", description: "Data  Log   BT  España        DL  EU0  91", name: "DL EU0" },
  { Modelo: "92", Ver: "0.0.0", description: "Data  Log   BT  EU+ RUS       DL  EU1  92", name: "DL EU1" },
  { Modelo: "93", Ver: "0.0.0", description: "Data  Log   BT  EU+Islandia   DL  EU2  93", name: "DL EU2" },
  { Modelo: "94", Ver: "0.0.0", description: "Data  Log   BT  Afri/Asia     DL  AOM  94", name: "DL AOM" },
  { Modelo: "95", Ver: "0.0.0", description: "Data  Log   BT  Israel        DL  ISR  95", name: "DL ISR" },
  { Modelo: "96", Ver: "0.0.0", description: "Data  Log   BT  Paci/Amer     DL  OCL  96", name: "DL OCL" },
  { Modelo: "98", Ver: "1.4.7", description: "Data  Log   BT  Italia        DL  EU3  98", name: "DL EU3" },
  { Modelo: "99", Ver: "0.0.0", description: "Data  Log   BT                DL  ETI  99", name: "DL ETI" },

  { Modelo: "D1", Ver: "1.4.7", description: "Data  Log2  BT  España        DL2 EU0  D1", name: "DL2 EU0" },
  { Modelo: "D2", Ver: "0.0.0", description: "Data  Log2  BT  EU+ Rusia     DL2 EU1  D2", name: "DL2 EU1" },
  { Modelo: "D3", Ver: "0.0.0", description: "Data  Log2  BT  EU+ Islandia  DL2 EU2  D3", name: "DL2 EU2" },
  { Modelo: "D4", Ver: "0.0.0", description: "Data  Log2  BT  Afri/Asia     DL2 EU2  D4", name: "DL2 EU2" },
  { Modelo: "D5", Ver: "0.0.0", description: "Data  Log2  BT  Israel        DL2 ISR  D5", name: "DL2 ISR" },
  { Modelo: "D6", Ver: "0.0.0", description: "Data  Log2  BT  Paci/Amer     DL2 OCL  D6", name: "DL2 OCL" },
  { Modelo: "D8", Ver: "1.4.8", description: "Data  Log2  BT  EU            DL2 EU3  D8", name: "DL2 EU3" },
  { Modelo: "D9", Ver: "0.0.0", description: "Data  Log2  BT                DL2 ETI  D9", name: "DL2 ETI" }
];

export const ANCNames = [

  {
    name: 'ANC EU0', //Modelo 51
    languages: ['spanish', 'english', 'italian', 'portuguese', 'french', 'german'],
    countries: [
      'Spain',
      'Portugal',
      'France',
      'Luxembourg',
      'Belgium',
      'Austria',
      'Italy',
      'Switzerland',
      'Germany',
      'UK',
      'Ireland',
      'Czech Republic'
    ]
  },

  {
    name: 'ANC EU1', //Modelo 52
    languages: ['norwegian', 'swedish', 'english', 'finnish'],
    countries: [
      'Norway',
      'Sweden',
      'Iceland',
      'Finland'
    ]
  },

  {
    name: 'ANC ETI', //Modelo 53
    languages: ['english', 'polsh', 'Lithuanian', 'Latvian', 'Estonian', 'Russian',  'Slovenian', 'BCS / Serbo-Croatian'],
    countries: [
      'Poland',
      'Slovenia',
      'Estonia',
      'Lithuania',
      'Latvia',
      'Russia',
      'Ukraine',
      'Bosnia and Herzegovina',
      'Croatia',
      'Macedonia',
      'Serbia'
    ]
  },
  {
    name: 'ANC RUS', //Modelo 54
    languages: ['russian', 'hungarian', 'romanian', 'ukrainian', 'english', 'french', 'german'],
    countries: [
      'Bielarus',
      'Hungary',
      'Russia',
      'Romania',
      'Ukraine',
    ]
  },
  {
  name: 'ANC AOM', //Modelo 55
  languages: ['english', 'french'],
  countries: [
    'Algeria',
    'Morocco',
    'Tunisia',
    'Egypt',
    'South Africa',
    'Saudi Arabia',
    'Bahrain',
    'UAE',
    'Iran',
    'Jordan',
    'Lebanon',
    'Qatar',
    'Syria',  ]
},
{
  name: 'ANC ISR', //Modelo 56
  languages: ['english', 'french', 'german'],
  countries: [
    'Israel'
  ]
},

{
  name: 'ANC OCE', //Modelo 57
  languages: ['english', 'french', 'german'],
  countries: [
    'AUS -DST',
    'AUS -NODST',
    'New Zealand'
  ]

},


  {
    name: 'ANC EU2', //Modelo 59
    languages: ['english', 'french', 'slovak', 'danish', 'dutch' , 'czech'],
    countries: [
      'Denmark',
      'Netherlands',
      'Slovakia',
      'Greece',
      'Malta',
      'Cyprus',
      'Czech Republic'
  ]
},
{
  name: 'ANC SUE', //Modelo 5A
  languages: ['german', 'french', 'english',  'italian', 'portuguese'],
  countries: [
    'Austria',
    'Belgium',
    'Cezech Republic',
    'Germany',
    'France',
    'Ireland',
    'Italy',
    'Luxembourg',
    'Switzerland',
    'UK'
  ]
},
{
  name: 'ANC LAT2', //Modelo 5B
  languages: ['spanish', 'english', 'french', 'portuguese', 'german', 'italian'],
  countries: [
    'Caribbean',
    'Central America',
    'Mexico',
    'Chile',
    'Uruguay',
    'Peru'
  ]

},
{
  name: 'ANC EU3', //Modelo 5C
  languages: ['finnish', 'english', 'italian', 'portuguese', 'french', 'german'],
  countries: [
    'Finland',
    'Portugal',
    'France',
    'Luxembourg',
    'Belgium',
    'Austria',
    'Italy',
    'Switzerland',
    'Germany',
    'UK',
    'Ireland'
  ]
},

{
  name: 'ANC EUE', //Modelo 5E
  languages: ['english', 'Polish', 'Lithuanian', 'Latvian', 'Keel','Slovenian', 'BCS' ],
  countries: [
    'Poland',
    'Slovenia',
    'Estonia',
    'Lithuania',
    'Latvia',
    'Ukraine',
    'Bosnia and Herzegovina',
    'Croatia',
    'Macedonia',
    'Serbia'
  ]
},

  // Astro Uno: mismas zonas e idiomas que el Nova City equivalente.
  // AN1 LAT (modelo 18) no tiene pareja: ANC LAT tampoco está definido aquí.
  {
    name: 'AN1 EU0', //Modelo 11, equivale a ANC EU0
    languages: ['spanish', 'english', 'italian', 'portuguese', 'french', 'german'],
    countries: [
      'Spain',
      'Portugal',
      'France',
      'Luxembourg',
      'Belgium',
      'Austria',
      'Italy',
      'Switzerland',
      'Germany',
      'UK',
      'Ireland',
      'Czech Republic'
    ]
  },
  {
    name: 'AN1 EU1', //Modelo 12, equivale a ANC EU1
    languages: ['norwegian', 'swedish', 'english', 'finnish'],
    countries: [
      'Norway',
      'Sweden',
      'Iceland',
      'Finland'
    ]
  },
  {
    name: 'AN1 ETI', //Modelo 13, equivale a ANC ETI
    languages: ['english', 'polsh', 'Lithuanian', 'Latvian', 'Estonian', 'Russian',  'Slovenian', 'BCS / Serbo-Croatian'],
    countries: [
      'Poland',
      'Slovenia',
      'Estonia',
      'Lithuania',
      'Latvia',
      'Russia',
      'Ukraine',
      'Bosnia and Herzegovina',
      'Croatia',
      'Macedonia',
      'Serbia'
    ]
  },
  {
    name: 'AN1 RUS', //Modelo 14, equivale a ANC RUS
    languages: ['russian', 'hungarian', 'romanian', 'ukrainian', 'english', 'french', 'german'],
    countries: [
      'Bielarus',
      'Hungary',
      'Russia',
      'Romania',
      'Ukraine',
    ]
  },
  {
    name: 'AN1 AOM', //Modelo 15, equivale a ANC AOM
    languages: ['english', 'french'],
    countries: [
      'Algeria',
      'Morocco',
      'Tunisia',
      'Egypt',
      'South Africa',
      'Saudi Arabia',
      'Bahrain',
      'UAE',
      'Iran',
      'Jordan',
      'Lebanon',
      'Qatar',
      'Syria',
    ]
  },
  {
    name: 'AN1 ISR', //Modelo 16, equivale a ANC ISR
    languages: ['english', 'french', 'german'],
    countries: [
      'Israel'
    ]
  },
  {
    name: 'AN1 OCE', //Modelo 17, equivale a ANC OCE
    languages: ['english', 'french', 'german'],
    countries: [
      'AUS -DST',
      'AUS -NODST',
      'New Zealand'
    ]
  },
  {
    name: 'AN1 EU2', //Modelo 19, equivale a ANC EU2
    languages: ['english', 'french', 'slovak', 'danish', 'dutch' , 'czech'],
    countries: [
      'Denmark',
      'Netherlands',
      'Slovakia',
      'Greece',
      'Malta',
      'Cyprus',
      'Czech Republic'
    ]
  },
  {
    name: 'AN1 SUE', //Modelo 1A, equivale a ANC SUE
    languages: ['german', 'french', 'english',  'italian', 'portuguese'],
    countries: [
      'Austria',
      'Belgium',
      'Cezech Republic',
      'Germany',
      'France',
      'Ireland',
      'Italy',
      'Luxembourg',
      'Switzerland',
      'UK'
    ]
  },
  {
    name: 'AN1 LAT2', //Modelo 1B, equivale a ANC LAT2
    languages: ['spanish', 'english', 'french', 'portuguese', 'german', 'italian'],
    countries: [
      'Caribbean',
      'Central America',
      'Mexico',
      'Chile',
      'Uruguay',
      'Peru'
    ]
  },
  {
    name: 'AN1 EU3', //Modelo 1C, equivale a ANC EU3
    languages: ['finnish', 'english', 'italian', 'portuguese', 'french', 'german'],
    countries: [
      'Finland',
      'Portugal',
      'France',
      'Luxembourg',
      'Belgium',
      'Austria',
      'Italy',
      'Switzerland',
      'Germany',
      'UK',
      'Ireland'
    ]
  },
  {
    name: 'AN1 EUE', //Modelo 1E, equivale a ANC EUE
    languages: ['english', 'Polish', 'Lithuanian', 'Latvian', 'Keel','Slovenian', 'BCS' ],
    countries: [
      'Poland',
      'Slovenia',
      'Estonia',
      'Lithuania',
      'Latvia',
      'Ukraine',
      'Bosnia and Herzegovina',
      'Croatia',
      'Macedonia',
      'Serbia'
    ]
  }

]


